<template>
  <v-form ref="deliveryDetailsForm" class="deliverydetails">
    <div class="text-xs-left subheading font-weight-bold ">Delivery Type</div>
    <v-layout class="ml-4 text-xs-left subheading" column>
      <div v-if="onlyInPerson">
        {{artistName}} will deliver to you next time they see you. (Please confirm with {{artistName}} before ordering!)
        <br />
        <br />
      </div>
      <div v-if="onlyMail">
        {{artistName}} will mail your items to you. {{ shippingStr}}
      </div>
      <v-radio-group
        validate-on-blur
        v-model="radioGroup"
        v-if="!onlyMail && !onlyInPerson"
        label="How do you want to get your items?"
        :rules="requiredRule"
      >
        <v-radio
          :key="1"
          :label="`In person (I will see ${artistName} soon)`"
          value="inperson"
        ></v-radio>
        <v-radio
          :key="2"
          label="Mail it to me"
          value="mail"
        ></v-radio>
      </v-radio-group>
    </v-layout>
  </v-form>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'DeliveryDetails',
  components: {
  },
  data: function () {
    return {
      helpTip: false,
      inperson: false,
      mail: false,
      radioGroup: null,
      requiredRule: [
        this.myRequired
      ]
    }
  },
  computed: {
    ...mapState({
      name: state => state.buyerInfo.name,
      artistName: state => state.shopping.name,
      mailDelivery: state => state.shopping.public_settings.acceptMailDelivery,
      inPersonDelivery: state => state.shopping.public_settings.acceptInPersonDelivery,
      deliveryType: state => state.cart.deliveryType,
      shippingType: state => state.shopping.public_settings.shippingType
    }),
    onlyMail: function () {
      return this.mailDelivery && !this.inPersonDelivery
    },
    onlyInPerson: function () {
      return !this.mailDelivery && this.inPersonDelivery
    },
    shippingStr: function () {
      if (this.shippingType === 'free') {
        return 'Free shipping!'
      } else {
        return ''
      }
    }
  },
  watch: {
    // onlyMail: function (val) {
    //   this.saveToCart()
    // },
    // onlyInPerson: function (val) {
    //   this.saveToCart()
    // },
    radioGroup: function () {
      this.saveToCart()
    }
  },
  mounted: function () {
    // Copy from the cart if it's there.
    if (this.deliveryType) {
      this.radioGroup = this.deliveryType
    }
    this.saveToCart()
  },
  methods: {
    myRequired (v) {
      if (this.onlyMail || this.onlyInPerson) return true
      return !!v || 'A selection is required'
    },
    saveToCart: function () {
      // Save the current form settings to the cart

      const deliveryType = this.getData()
      console.log('Setting del type: ' + JSON.stringify(deliveryType))
      this.$store.dispatch('cart/setDeliveryType', deliveryType)
    },
    getData: function () {
      // Returns the form data
      let deliveryType = null
      if (this.onlyMail) {
        deliveryType = 'mail'
      } else if (this.onlyInPerson) {
        deliveryType = 'inperson'
      } else {
        deliveryType = this.radioGroup
      }

      return deliveryType
    },
    isValid: function () {
      const formIsValid = this.$refs.deliveryDetailsForm.validate()
      // this.$v.$touch()
      // return this.$v.$invalid
      return formIsValid
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
